'use struct';

export function ga_notlogin() {
  if (typeof ga !== 'undefined') {
    ga('send', 'event', 'not_login', '2.未ログインの場合', '/login.php?from=%2Faccount%2Fmembership%2Fpayment%3Fplan%3D1&c-ms-mode=1');
  }
}

export function ga_sns() {
  if (typeof ga !== 'undefined') {
    ga('send', 'event', 'sns_login', '2-1-1.ソーシャルログインの場合', '/login.php?login-mode=social&c-ms-mode=1');
  }
}

export function ga_login() {
  if (typeof ga !== 'undefined') {
    ga('send', 'event', 'id_login', '2-1-2.IDログインの場合', '/login.php?login-mode=id&c-ms-mode=1');
  }
}
